import React from 'react';

import { SectionCard } from '~components';
import Icon, { faInfoCircle } from '~components/icon';
import { Column, Row, TableView } from '~components/table-view';

interface ComponentProps {
  title: string;
  description: string;
  columns: Column[];
  data: Row[];
  dataCy: string;
}

export const DashboardTable: React.FC<ComponentProps> = ({ title, description, columns, data, dataCy }) => {
  return (
    <SectionCard title={title} description={description} className="dashboard-table">
      {data.length > 0 ? (
        <TableView id={dataCy} data={data} columns={columns} readonly />
      ) : (
        <div className="no-data" role="status">
          <Icon icon={faInfoCircle} />
          No data available for the selected period.
        </div>
      )}
    </SectionCard>
  );
};
